import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    // Verificação de permissões (Role) para rotas administrativas
    const requiredRole = route.data['role'];
    if (requiredRole && authService.getUserRole() !== requiredRole) {
      return router.createUrlTree(['/']);
    }
    return true;
  }

  // Guarda a intenção de retornar à rota pedida após o login
  localStorage.setItem('redirect_after_login', state.url);
  return router.createUrlTree(['/login']);
};

// Rotas de compra (montar kit, carrinho): abertas a visitantes e clientes.
// O admin não faz pedidos, por isso é devolvido ao painel.
export const shoppingGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAdmin() ? router.createUrlTree(['/admin']) : true;
};
